import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { Sidebar } from "./Sidebar";

interface DashboardLayoutProps {
  children: ReactNode;
}

export function DashboardLayout({ children }: DashboardLayoutProps) {
  return (
    <div className="min-h-screen bg-[var(--color-surface-secondary)]">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:z-50 focus:p-4 focus:bg-white focus:text-blue-600"
      >
        Skip to content
      </a>
      <Sidebar />

      {/* Main content area offset by sidebar width */}
      <main id="main-content" className="ml-[var(--sidebar-width)] min-h-screen">
        <div className="mx-auto max-w-7xl px-6 py-8">
          {children}
        </div>

        {/* Footer */}
        <footer className="ml-0 border-t border-[var(--color-border)] px-6 py-4">
          <div className="mx-auto flex max-w-7xl items-center justify-between text-xs text-[var(--color-text-muted)]">
            <span>ChargeSuite GmbH</span>
            <nav aria-label="Footer">
              <ul className="flex gap-4">
                <li>
                  <Link to="/privacy" className="hover:underline">
                    Privacy Policy
                  </Link>
                </li>
                <li>
                  <Link to="/terms" className="hover:underline">
                    Terms of Service
                  </Link>
                </li>
              </ul>
            </nav>
          </div>
        </footer>
      </main>
    </div>
  );
}
